import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as _ from 'lodash';
import { from, Observable, Subject } from 'rxjs';
import { first, switchMap, takeUntil } from 'rxjs/operators';
import Utils from '../_helpers/utils';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor(
    private http: HttpClient,
    private stateStore: Store
  ) { }

  getBase64FromUrl(url: string) {
    return this.http.get(url)
      .pipe(
        switchMap((data: Blob) => from(Utils.getBase64(data))),
      );
  }

  getBase64FromExternalUrl(url: string): Promise<string | ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = () => {
        const canvas = document.createElement("canvas");
        // canvas.width = img.width;
        // canvas.height = img.height;

        const context = canvas.getContext("2d");
        context.drawImage(img, 0, 0);

        const dataUrl = canvas.toDataURL();
        resolve(dataUrl);
      };
      img.onerror = error => {
        reject(error);
      };
      img.src = url;
    });
  }

  memoizedSelector$<K, T>(selector: (...values: K[]) => (state: any, ...states: any[]) => T, options?: { throttleTime: number }) {
    let stateSelector: Observable<T>;
    let previousValues: K[];
    let destroySubject = new Subject<boolean>();
    return (...values: K[]) => {
      if (values.some(value => value instanceof Function))
        throw Error("Function Not Allowed .....");
      if (!_.isEqual(values, previousValues)) {
        destroySubject.next(true);
        destroySubject.unsubscribe();
        destroySubject = new Subject<boolean>();
        stateSelector = this.stateStore.select(selector(...values)).pipe(takeUntil(destroySubject));
        previousValues = _.cloneDeep(values);
      }
      return stateSelector;
    }
  }

  memoizedFunction<T, K>(func: (...params: K[]) => T) {
    let cachedResult: T;
    let previousParams: K[];
    return (...params: K[]) => {
      if (!cachedResult || !_.isEqual(params, previousParams)) {
        cachedResult = func(...params);
        previousParams = _.cloneDeep(params);
      }
      return cachedResult;
    }
  }

  
  /**
   * Makes an authenticated request to retreive an image 
   * @returns returns an image file 
   */
   loadAuthImage(url: string): Observable<string> {
    const dataUrlObservable = (res: Blob) => new Observable<string>(s => {
      const reader = new FileReader();
      reader.readAsDataURL(res);
      reader.onload = () => {
        s.next(reader.result as string);
        s.complete();
      }
      reader.onerror = (error) => s.error(error);
    });

    return this.http.get(url, { responseType: 'blob' })
      .pipe(
        first(),
        switchMap(dataUrlObservable)
      );
    //return this.http.get(url, { responseType: 'blob' });
  }

  get doc() {
    return document;
  }
}

